<template>
    <section
        v-if="total"
        class="mt-9 flex flex-start flex-wrap gap-4 max-w-[718px] w-full"
    >
        <div
            v-for="(page, key) in pages"
            :key="key"
            @click="setPage(page.page)"
            class="p-2 border-2 rounded-2xl border-primary flex justify-center items-center text-xl font-bold cursor-pointer"
            :class="
                currentPage == page.page
                    ? 'bg-primary text-white'
                    : 'bg-white text-primary'
            "
        >
            <Icon v-if="page?.alias" name="ChevronP" :class="{'rotate-180': page?.alias === 'prev'}"/>
            <label v-else>
                {{ page?.alias || page.page + 1 }}
            </label>
        </div>
    </section>
</template>

<script>
import Icon from './Icons/Icon.vue';
export default {
    emits: ["page:selected"],
    props: {
        total: Number,
        limit: Number,
        startPage: Number,
    },
    data() {
        return {
            currentPage: this.startPage || 0,
        };
    },
    watch: {
        'startPage': {
            handler(newValue) {
                this.currentPage = newValue;
            }
        },
    },
    computed: {
        pages() {
             const totalPages = Math.ceil(this.total / this.limit);
            const lastPage = totalPages - 1;
            const pages = [];
            pages.push({
                page: 0,
            });
            if (this.currentPage != 0) {
                pages.push({
                    alias: "prev",
                    page: this.currentPage - 1,
                });
            }
            for (let i = -4; i + this.currentPage < this.currentPage + 5; i++) {
                const page = i + this.currentPage;
                if (page > 0 && page < lastPage) {
                    pages.push({
                        page,
                    });
                }
            }
            if (lastPage > 0) {
                if (lastPage != this.currentPage) {
                    pages.push({
                        alias: "next",
                        page: this.currentPage + 1,
                    });
                }
                pages.push({
                    page: lastPage,
                });
            }
            return [...pages];
        },
    },
    methods: {
        setPage(page) {
            this.currentPage = page;
            this.$emit("page:selected", page);
        },
    },
    components: { Icon }
};
</script>
